import React from 'react';

import Globals from '../../../utility/constants/appConstants';

import { calculateServiceCount,toolTipCalculate} from '../../../utility/features/helpers/serviceDetailsHelper';

import ToolTip from '../../ui/toolTip.js';

function PrePayServices({ isActionEnabled, data, labels, year, serviceDetailsCss }) {
  const { totalServicesCompleted, servicesRemaining, lastServiceDate } = calculateServiceCount(data, year);
  const toolTip = toolTipCalculate(data, labels);
  const dollars = labels.dollarsPP;
  const cents = labels.centsPP;

  return (
    <React.Fragment>
      <div className='row d-md-none'>
        <div className='col-12 p-0'>
          <hr className='mb-16 mt-0 w-100' />
        </div>
      </div>
      <div className='row d-md-none'>
        <div className={`col-12 ${serviceDetailsCss['gfs-20']}`}>
          <div className='glh-1_2'>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']}`}>
                {labels.servicesCompleted}
              </span>
              <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['text-gray-med']}`}>
                {totalServicesCompleted}
              </span>
            </div>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']}`}>
                {`${labels.servicesRemaining} ${year}: `}
              </span>
              {data.svcLine && <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                {servicesRemaining}
              </span>}
            </div>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']}`}>
                {labels.lastServiceDate}
              </span>
              {data.svcLine && <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                {lastServiceDate}
              </span>}
            </div>
            <div>
              <span className={`${serviceDetailsCss['gfw-3']} text-green`}>
                {labels.prepaid}
              </span>
            </div>
          </div>
          <div className='glh-1_2 mb-16'>
            <span className={`${serviceDetailsCss['gfw-3']}`}>{labels.amountDue}</span>
            {data.svcLine && <span className={`${serviceDetailsCss['gfw-7']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>${dollars}<sup>{cents}</sup></span>}
            <ToolTip toolTip={toolTip} tooltipdata={labels.tooltipdata} tooltipsmbl={labels.tooltipsmbl} parentCss={serviceDetailsCss} />
          </div>
          
        </div>
      </div>
      <div className='d-none d-md-flex row mb-16 mb-md-0 mb-lg-16'>
        <div className='col-12 col-md d-flex mb-md-16 mb-lg-0'>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 mb-1`}>
              {labels.servicesCompleted}
            </div>
            <div className={`align-items-end d-flex flex-fill ${serviceDetailsCss['gfs-50']} ${serviceDetailsCss['gfw-9']} glh-1 justify-content-center ${serviceDetailsCss['text-gray-med']}`}>
              {totalServicesCompleted}
            </div>
          </div>
        </div>
        <div className='col-12 col-md d-flex mb-md-16 mb-lg-0'>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 mb-1`}>
              {`${labels.servicesRemaining} ${year}`}:
            </div>
            {data.svcLine && <div
              className={`align-items-end d-flex flex-fill ${serviceDetailsCss['gfs-50']} ${serviceDetailsCss['gfw-9']} glh-1 justify-content-center ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              {servicesRemaining}
            </div>}
          </div>
        </div>
        <div className='col-12 col-md d-flex mb-md-16 mb-lg-0'>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 mb-1`}>
              {labels.lastServiceDate}
            </div>
            {data.svcLine && <div
              className={`align-items-end d-flex flex-fill ${serviceDetailsCss['gfs-20']} ${serviceDetailsCss['gfw-9']} glh-1 justify-content-center ${serviceDetailsCss['pb-12']} ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
              {lastServiceDate}
            </div>}
          </div>
        </div>
        <div className='col-12 col-md-8 col-lg-4 d-flex mb-md-16 mb-lg-0'>
          <div className={`${serviceDetailsCss['bg-white']} d-flex flex-column glh-1_1 p-10 text-center ${serviceDetailsCss['tru-mma-main-service-box']} position-relative ${serviceDetailsCss["tru-mma-main-side"]} w-100`}>
            <div className={`${serviceDetailsCss['gfs-14']} ${serviceDetailsCss['gfw-3']} glh-1_2 mb-1`}>
              {labels.prePaid}
            </div>
            <div className='align-items-center d-flex flex-column flex-fill justify-content-end'>
              <div className={`${serviceDetailsCss['gfs-16']}`}>{labels.amountDue}</div>
              {data.svcLine && <div
                className={`d-block ${serviceDetailsCss['gfs-50']} ${serviceDetailsCss['gfs-md-40']} ${serviceDetailsCss['gfw-7']} glh-1_2 ${serviceDetailsCss['service-line']} service-line--${(data.svcLine).toLowerCase()}`}>
                <span>{Globals.currencySymbol}{dollars}</span>
                <sup className={`${serviceDetailsCss['gfs-md-22']}`}>
                  {cents}
                </sup>
              </div>}
            </div>
            <ToolTip toolTip={toolTip} tooltipdata={labels.tooltipdata} tooltipsmbl={labels.tooltipsmbl}  parentCss={serviceDetailsCss} />
            
          </div>
        </div>
      </div>   
    </React.Fragment>
  );
}

export {
  PrePayServices,
};